import { Button, Avatar } from '@mui/material';
import { H5, Body3, Body1 } from '../../themes/typography';

const avatar =
    'https://images.unsplash.com/photo-1623582854588-d60de57fa33f?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';

function OrganizeBy({ organizerName = 'Shmooz' }) {
    return (
        <div className="preview-organize-by-container">
            <H5 fontWeight={700}>Event By</H5>

            <div className="preview-organize-by-details-container">
                <div className="organizer-profile-container">
                    {/* {avatar} */}

                    <Avatar
                        src={avatar}
                        alt="Organizer Profile"
                        sx={{
                            width: 54,
                            height: 54,
                            borderRadius: '50%'
                        }}
                    />

                    <div className="organizer-name-followers">
                        <div className="organizer-name-container">
                            <Body1 fontWeight={500}>{organizerName}</Body1>
                        </div>
                        {/* <div className="organizer-followers-container">
                            <Body3>
                                123 Followers
                            </Body3>
                        </div> */}
                    </div>
                </div>
                {/* <Button variant="main">
                    Follow
                </Button> */}
            </div>
        </div>
    );
}

export default OrganizeBy;
